import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppStiRanking } from '../models/mobileAppStiRanking';

@Component({
  template: ` <div class="d-flex justify-content-start">
    <img
      src="https://cdn.pixalate.com/icons/countries/flat/48/{{
        data?.countryCode
      }}.png"
      alt="{{ data?.countryCode }} Icon"
      onerror="this.src='/assets/icons/icon-72x72-grey.png'"
      class="mx-2 rounded"
      width="16"
    />
    <span class="text-truncate">{{ data?.countryName }}</span>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerCountryComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppStiRanking;

  ngOnInit() {
    super.ngOnInit();
  }
}
